export default function main() {
    const $bannerEls = Array.from(document.querySelectorAll('.holiday-banner'));
    for (const $banner of $bannerEls) {
        const $bannerBtn = $banner.querySelector('.banner-expand-collapse') as HTMLAnchorElement;
        const $bannerText = $banner.querySelector('.banner-text') as HTMLElement;

        if (!window.localStorage.getItem('holidayBannerCollapsed')?.length) {
            $bannerBtn.querySelector('.btn-chevron')?.classList.add('chevron-rotated');
        }
        $bannerBtn.addEventListener('click', e => {
            e.preventDefault();
            toggleExpandCollapse($bannerText, $bannerBtn);
        });
    }

    const toggleExpandCollapse = ($textEl: HTMLElement, $btn: HTMLElement) => {
        $textEl.style.setProperty('--scroll-height', `${$textEl.scrollHeight}px`);

        setTimeout(() => {
            if ($textEl.classList.contains('collapsed')) {
                window.localStorage.setItem('holidayBannerCollapsed', '');
                $textEl.classList.remove('collapsed');
                $btn.querySelector('.btn-chevron')?.classList.add('chevron-rotated');
            } else {
                window.localStorage.setItem('holidayBannerCollapsed', 'collapsed');
                $textEl.classList.add('collapsed');
                $btn.querySelector('.btn-chevron')?.classList.remove('chevron-rotated');
            }
        });
    };
}
